module.exports = __webpack_public_path__ + "assets/4c1b0d691b927df0eaad0c6efe2d6e90.mp4";